export const Constants = {
	AppTileWidth: 450
};
